import { Metaplex } from "@metaplex-foundation/js";
import { useConnection } from "@solana/wallet-adapter-react";
import type { NFTStakingPosition } from "@stepfinance/nft";
import { StarAtlasShipStakingFetcher } from "@stepfinance/nft";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { useMarkets } from "../../../contexts/market";
import { getTokenByMint } from "../../../utils/tokenInfo";
import { useConnectedWallet } from "../../wallet";

export const useStarAtlasShipStakingQuery = () => {
  const { connection } = useConnection();
  const wallet = useConnectedWallet();
  const { priceInUSD, marketsInitialised } = useMarkets();

  const fetcher = useMemo(() => {
    if (wallet) {
      const metaplex = new Metaplex(connection);
      return new StarAtlasShipStakingFetcher({ connection, wallet, metaplex, getTokenByMint });
    }
  }, [connection, wallet]);

  return useQuery<NFTStakingPosition[]>(
    ["starAtlasShipStaking", fetcher?.wallet.publicKey.toBase58()],
    async () => {
      if (fetcher) {
        return await fetcher.fetchPositions(priceInUSD);
      }
      return [];
    },
    {
      retry: false,
      enabled: !!fetcher && marketsInitialised && !!priceInUSD,
    },
  );
};
